// FAQ filter — category tabs + live search (ligo.pe-style).
//
// Category pills filter the visible group ("Todas" shows every group). The
// search box matches across all questions/answers and overrides the active tab
// while typing. Accent-insensitive. Progressive enhancement: without JS every
// category group renders stacked and fully reachable.

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-faq-filter]').forEach((filter) => {
    const root   = filter.closest('.faq-section') || document
    const tabs   = Array.from(filter.querySelectorAll('[data-faq-tab]'))
    const groups = Array.from(root.querySelectorAll('[data-faq-group]'))
    const search = filter.querySelector('[data-faq-search]')
    const empty  = root.querySelector('[data-faq-empty]')
    if (!groups.length) return

    const norm = (s) =>
      s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')

    let activeCat = tabs.length ? tabs[0].dataset.faqTab : null

    function showCategory(cat) {
      activeCat = cat
      tabs.forEach((t) => {
        const on = t.dataset.faqTab === cat
        t.classList.toggle('is-active', on)
        t.setAttribute('aria-selected', on ? 'true' : 'false')
      })
      groups.forEach((g) => {
        g.hidden = cat !== 'all' && g.dataset.faqGroup !== cat
        g.querySelectorAll('[data-faq-item]').forEach((it) => { it.hidden = false })
      })
      if (empty) empty.hidden = true
    }

    function runSearch(value) {
      const q = norm(value.trim())
      if (!q) { showCategory(activeCat); return }

      let any = false
      groups.forEach((g) => {
        let groupHas = false
        g.querySelectorAll('[data-faq-item]').forEach((it) => {
          const match = norm(it.textContent).includes(q)
          it.hidden = !match
          if (match) groupHas = true
        })
        g.hidden = !groupHas
        if (groupHas) any = true
      })
      tabs.forEach((t) => {
        t.classList.remove('is-active')
        t.setAttribute('aria-selected', 'false')
      })
      if (empty) empty.hidden = any
    }

    tabs.forEach((t) =>
      t.addEventListener('click', () => {
        if (search) search.value = ''
        showCategory(t.dataset.faqTab)
      })
    )
    if (search) search.addEventListener('input', () => runSearch(search.value))

    if (activeCat) showCategory(activeCat)
  })
})
